import { SortBy, useStats } from 'react-instantsearch'

export default function FilterSortToolbar() {
  const { nbHits } = useStats()

  return (
    <div className="flex justify-between gap-x-l border-b border-gradient pb-m s:items-center s:pb-s s-up:items-end">
      {nbHits ? <span className="text-19 text-grey-950 ms:text-16">{nbHits} Results</span> : null}

      <div className="flex items-center gap-x-s">
        <span className="text-17 font-bold ms:text-14">Sort by:</span>
        <SortBy
          classNames={{
            select: 'text-17 shadow-none pl-0 py-0 min-h-0 bg-[length:12px_12px]',
          }}
          items={[
            { label: 'Relevance', value: 'wp_searchable_posts' },
            { label: 'Newest', value: 'wp_searchable_posts_newest' },
            { label: 'Oldest', value: 'wp_searchable_posts_oldest' },
          ]}
        />
      </div>
    </div>
  )
}
